import {
  BULK_TAG_RESOURCE_URL,
  MAP_PROJECT_BASE_URL,
  MAP_PROJECT_COUNT_SUMMARY,
  MAP_PROJECT_CREATE_URL,
  MAP_PROJECT_DETAIL_URL,
  MP_PROJECT_UPDATE_URL,
  SUPPORTED_SERVICES_URL,
} from "../../config/service";
import { RESOURCE_MASTER_OBJ } from "../mockData/mapProject/map-resources-mock-data";

import {
  MAP_PROJECT_Count_Summary_MockData,
  MAP_PROJECT_DETAILS_MOCKDATA,
  MAP_PROJECT_LIST_MOCKDATA,
} from "../mockData/mapProject/mapProject-mock-data";
import { IN_PROGRESS_ID, MAP_SERVICES_LIST } from "./map-services-constants";

const Tagged_Resource = "TAGGED"
const Untagged_Resource = "UNTAGGED";

export const setUpMAPProjectsServices = (mock) => {
  mock.onGet(`${MAP_PROJECT_COUNT_SUMMARY}`).reply(async (config) => {
    return [200, MAP_PROJECT_Count_Summary_MockData];
  });

  mock.onGet(SUPPORTED_SERVICES_URL).passThrough();

  mock
    .onGet(
      `${MAP_PROJECT_BASE_URL}?Filters=%7B%22Status%22:%22IN-PROGRESS%22%7D&Limit=10&Offset=0&KeywordSearch=%5B%7B%22Field%22:%22Name%22,%22Value%22:%22%22%7D%5D`
    )
    .reply(async (config) => {
      return [200, MAP_PROJECT_LIST_MOCKDATA];
    });

  mock
    .onGet(`${MAP_PROJECT_DETAIL_URL}${IN_PROGRESS_ID}`)
    .reply(async (config) => {
      return [200, MAP_PROJECT_DETAILS_MOCKDATA];
    });

  mock.onPatch(new RegExp(`${MP_PROJECT_UPDATE_URL}`)).reply(() => {
    return [200, MAP_PROJECT_DETAILS_MOCKDATA];
  });

  mock.onDelete(new RegExp(`${MP_PROJECT_UPDATE_URL}`)).reply(() => {
    return [200, MAP_PROJECT_DETAILS_MOCKDATA];
  });

  const serviceDetailsUrl = new RegExp(
    `${MAP_PROJECT_DETAIL_URL}${IN_PROGRESS_ID}/service-details`
  );

  mock.onGet(serviceDetailsUrl).reply(async (config) => {
    const decodedURL = decodeURI(config.url);
    const url = new URLSearchParams(decodedURL);
    const filter = JSON.parse(
      decodedURL.split("?")[1].split("&")[0].replace("Filters=", "")
    );
    const limit = Number(url.get("Limit"));
    const offset = Number(url.get("Offset"));
    const serviceType = url.get("ServiceType");
    return [200, getResourcesResponse({ filter, limit, offset, serviceType })];
  });

  const servicesUrl = new RegExp(
    `${MAP_PROJECT_DETAIL_URL}${IN_PROGRESS_ID}/services`
  );

  mock.onGet(servicesUrl).reply(async (config) => {
    const decodedURL = decodeURI(config.url);
    const url = new URLSearchParams(decodedURL);
    const filter = JSON.parse(
      decodedURL.split("?")[1].split("&")[0].replace("Filters=", "")
    );
    const limit = Number(url.get("Limit"));
    const offset = Number(url.get("Offset"));
    const resp = getServicesResponse(filter, limit, offset);

    return [200, resp];
  });

  mock.onPost(new RegExp(`${MAP_PROJECT_CREATE_URL}`)).reply(async (config) => {
    const response = {
      MapProjectId: IN_PROGRESS_ID,
    };
    return [200, response];
  });

  mock.onPost(new RegExp(`${BULK_TAG_RESOURCE_URL}`)).reply(async (config) => {
    return [200];
  });
};

const getServicesResponse = (filters, limit, offset) => {
  let response = {};
  const filteredList = [...MAP_SERVICES_LIST];
  const startIndex = offset * limit;
  const endIndex = startIndex + limit;
  const items = filteredList.slice(startIndex, endIndex);
  if (filteredList.length > items.length) {
    response = {
      offset: offset + 1,
    };
  }
  response = {
    ...response,
    Items: items,
  };
  return response;
};

const getResourcesResponse = ({ filter, limit, offset, serviceType }) => {
  let response = {};
  const resourceMasterList = RESOURCE_MASTER_OBJ[serviceType];
  const resourceList = resourceMasterList.filter((item) => {
    let condition2 = true;
    if (filter.Resources === Untagged_Resource) {
      condition2 = item.IsTagged === false;
    }
    if (filter.Resources === Tagged_Resource) {
      condition2 = item.IsTagged === true;
    }
    return condition2;
  });
  const startIndex = offset * limit;
  const endIndex = startIndex + limit;
  const items = resourceList.slice(startIndex, endIndex);
  if (resourceList.length > items.length) {
    response = {
      offset: offset + 1,
    };
  }
  response = {
    ...response,
    Items: items,
  };
  return response;
};
